export function formatMedicationSummaryDetails(medication) {
  return [medication?.dosage ?? medication?.Dosage, medication?.frequency ?? medication?.Frequency]
    .filter(Boolean)
    .join(' • ');
}

export function isActiveMedication(medication) {
  return (medication?.status ?? medication?.Status ?? 'active').toLowerCase() === 'active';
}

export function groupMedications(medications = []) {
  return {
    current: medications.filter(isActiveMedication),
    past: medications.filter(medication => !isActiveMedication(medication)).sort((a, b) => {
      const endedAt = medication => Date.parse(medication.endDate || medication.updatedAt || medication.createdAt) || 0;
      return endedAt(b) - endedAt(a);
    }),
  };
}
